import {useState} from "react";
import DetailPersonalityRequest from "./DetailPersonalityRequest";
import PersonalityRequests from "./PersonalityRequests";

export default function Index() {

    const [detailId, setDetailId] = useState("")

    return(
        detailId ?
            <DetailPersonalityRequest setDetailId={setDetailId} detailId={detailId}/>
            :
            <PersonalityRequests setDetailId={setDetailId} />
    )
}